module.exports = __webpack_public_path__ + "static/media/brochure.ba7ff322.png";